<script lang="ts">
    import cn from '$common/utils/cn';
    import Button from '$saga/components/Button.svelte';
    import { filtersContext } from '$saga/views/Search/store';
</script>

<div
    class="no-scrollbar flex min-h-fit w-full justify-between gap-xs overflow-x-scroll border-t border-solid border-border-quiet bg-white py-s"
>
    {#each [0, 1, 2, 3, 5, 7] as index}
        <Button
            size="small"
            intent="secondary"
            class={cn(
                'whitespace-nowrap rounded-full border-border-quiet text-xs capitalize',
                $filtersContext.formValues.flexibility === index &&
                    'border-border-brand text-content-brand',
            )}
            on:click={() => {
                $filtersContext.formValues.flexibility = index;
            }}
        >
            {#if index === 0}
                Dates exactes
            {:else}
                ± {index} jour{index > 1 ? 's' : ''}
            {/if}
        </Button>
    {/each}
</div>
